<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<div class="flex-wrap-spacing">
				<h3 class="page-header">Namespaces</h3>
			</div>
			<div class="flex-wrap-spacing namespaces-actions">
				<button class="btn btn-primary tests_add_namespace_action" @click="goToAddNamespace()">
					<i class="fa fa-plus fa-fw"></i>New Namespace</button>
			</div>
		</template>

		<template slot="admin-page-content">
			<loader v-if="!namespaces"></loader>

			<div class="row" v-if="namespaces && namespaces.length == 0">
				<div class="col-xs-12">
					No namespaces yet.
				</div>
			</div>

			<div class="row" v-if="namespaces && namespaces.length > 0">
				<div class="col-xs-12 pad0">
					<div class="table-responsive">
						<table class="table table-hover tests_namespaces_table">
							<thead>
								<tr>
									<th>Name</th>
									<th>Created</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="namespace in namespaces" v-bind:key="namespace.name">
									<td class="tests_namespace_name">{{ namespace.namespace }}</td>
									<td>{{ namespace.createdAt | moment("from", "now") }}</td>
									<td class="table-item-actions">
										<a @click="deleteNamespace(namespace.namespace)" class="tests_delete_namespace_action">
											<i class="fa fa-times"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
	</admin-base-layout>
</template>

<script>
const logger = require("@/utils/logger");
const namespaceService = require("@/utils/namespace-api");
import router from "@/router";
const utils = require("@/utils/utils")

export default {
  data() {
    return {
      namespaces: null
    };
  },
  methods: {
    getNamespaces() {
      namespaceService
        .list()
        .then(namespaces => {
          this.namespaces = namespaces;
        })
        .catch(utils.axiosErrorHandler);
    },
    deleteNamespace(name) {
      if (!confirm("Delete namespace " + name + "?")) return;
      
      namespaceService
        .remove(name)
        .then(r => {
          for (var i in this.namespaces) {
            if (this.namespaces[i].namespace == name) {
              this.namespaces.splice(i, 1);
              return;
            }
          }
        })
        .catch(utils.axiosErrorHandler);
    },
    goToAddNamespace() {
      router.push("/namespaces/new");
    }
  },
  mounted() {
    this.getNamespaces();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 10px;
  text-align: center;
}
.table-item-actions {
  text-align: right;
}

.namespaces-actions {
  text-align: right;
  flex: 1;
}
.flex-wrap-spacing {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Namespaces.vue